import Image from 'next/image'
import carDressLogo from './cardress.png'

type IconProps = {
  className?: string
}

const CarDressLogo: React.FC<IconProps> = ({ ...attributes }) => {
  return <Image src={carDressLogo} alt="CarDress Logo" height={48} {...attributes} />
}

export default CarDressLogo
